// ============================================================
// No-show risk per loading (#67). A transparent score, not a trained
// model: the carrier's no-show rate in the demo history (last 30 days)
// adjusted by what we know about the loading today. Every point of the
// score has a reason the planner can read. A real model needs OMYA's
// own history (see the ADR, AI layer).
// ============================================================

import { carrierScorecard } from '@/data/carrierStats';

const byCarrier = Object.fromEntries(carrierScorecard(30).map(({ carrier, now }) => [carrier.id, now]));
const NO_RISK = ['loaded', 'on-site', 'not-coming'];

export const RISK_HIGH = 0.35;
const RISK_MEDIUM = 0.15;

// { level: 'low' | 'medium' | 'high', score, reasons: [{ key, vars }] } or null when the outcome is known.
export function noShowRisk(loading) {
  if (NO_RISK.includes(loading.state)) return null;
  const stats = byCarrier[loading.carrierId];
  const reasons = [];
  let score = stats ? stats.noShowPct / 100 : 0.1;
  if (stats) reasons.push({ key: 'ai.risk.reason.carrier', vars: { pct: Math.round(stats.noShowPct) } });

  if (loading.state === 'no-info') { score += 0.15; reasons.push({ key: 'ai.risk.reason.noInfo' }); }
  if (loading.state === 'no-power') { score += 0.15; reasons.push({ key: 'ai.risk.reason.noPower' }); }
  if (loading.state === 'rescheduled') { score += 0.1; reasons.push({ key: 'ai.risk.reason.rescheduled' }); }
  if (loading.state === 'confirmed') { score *= 0.5; reasons.push({ key: 'ai.risk.reason.confirmed' }); }
  if (loading.state === 'en-route') { score *= 0.3; reasons.push({ key: 'ai.risk.reason.enRoute' }); }

  if (new Date(loading.plannedAt).getHours() >= 14) { score += 0.08; reasons.push({ key: 'ai.risk.reason.afternoon' }); }
  if (stats && stats.outOfHours >= 3) { score += 0.05; reasons.push({ key: 'ai.risk.reason.outOfHours', vars: { n: stats.outOfHours } }); }
  if (!loading.plate || loading.plate === '—') { score += 0.1; reasons.push({ key: 'ai.risk.reason.noPlate' }); }

  const level = score >= RISK_HIGH ? 'high' : score >= RISK_MEDIUM ? 'medium' : 'low';
  return { level, score: Math.min(1, score), reasons };
}

export const riskStyles = {
  high: 'border-red-300 bg-red-50 text-red-700',
  medium: 'border-amber-300 bg-amber-50 text-amber-800',
  low: 'border-emerald-200 bg-emerald-50 text-emerald-700',
};
